import { Component, OnInit, ViewEncapsulation, ElementRef, OnDestroy, Renderer2, AfterViewInit, AfterViewChecked } from "@angular/core";
import { MessageType, NotificationType, UserNotification } from "src/app/models";
import { LoggingService, SecurityService, SignalRService, StorageService, LoaderService, MedPointToastService } from "src/app/services";
import moment from "moment";
import { environment } from "src/environments/environment";
import { Constants } from "src/app/shared/models/constants";
import { TopNotificationService } from "src/app/shared/components/top-notification/top-notification.service";
import * as _ from "lodash";
import * as XLSX from 'xlsx';
import { ActiveToast } from 'ngx-toastr';
import { Subscription } from "rxjs";
import { MedptToastComponent } from "src/app/shared/components/medpt-toast/medpt-toast.component";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
declare var $: any;

@Component({
    selector: "medpt-user-notification",
    templateUrl: "./user-notification.component.html",
    styleUrls: ["./user-notification.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UserNotificationComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  //https://angular.io/guide/zone#when-apps-update-html

  signalList: UserNotification[] = [];
  notificationIcon: string;
  subscriptions: Array<Subscription> = [];
  constructor(
    private signalrService: SignalRService,
    private storageService: StorageService,
    private loggingService: LoggingService,
    private securityService: SecurityService,
    private loaderService: LoaderService,
    private topNotificationService: TopNotificationService,
    private elementRef: ElementRef,
    private medptToastr: MedPointToastService,
    private sanitizer: DomSanitizer
  ) {
    this.notificationIcon = "notif-bell.svg";
  }

  ngOnInit(): void {
    const currentUser = this.securityService.currentUserValue;
    this.loadNotifications(currentUser.UserGuid);
  }

  ngAfterViewInit() {
    $(document).on('click touch', '.toast-container a', (e: any) => {
      this.initDownload(e);
    });
  }


  ngAfterViewChecked() {    

    let anchorElms = this.elementRef.nativeElement.querySelectorAll('.inapp-message a');
    if (anchorElms.length > 0) {
      for (let i = 0; i < anchorElms.length; i++) {
        anchorElms[i].onclick = (e: any) => {
          this.initDownload(e);
        }
      }
    }
  }

  private initDownload(e: any) {
    var fileName = e.target.getAttribute('data-download-filename');
    var jsonObject = e.target.getAttribute('data-download-result');
    var resultFileId = e.target.getAttribute('data-download-resultid');

    if (jsonObject != null && jsonObject != undefined) {
      try {
        this.loaderService.showLoader();
        let downloadData = [];
        try {
          downloadData = JSON.parse(jsonObject);
        } catch (e) {
          downloadData = JSON.parse(atob(jsonObject));
        }
        var sheetHeader = e.target.getAttribute('data-download-sheetheader') != undefined ? JSON.parse(atob(e.target.getAttribute('data-download-sheetheader'))) : [];
        downloadData.forEach((value: any) => {
          if (value.EnrollmentMonth != undefined) {
            value.EnrollmentMonth = moment(value.EnrollmentMonth).format("MMM-YYYY");
          }
        });

        if (fileName.includes('Import_FAQ_Data_Results'))
          this.ExportFAQ(downloadData, fileName + ".xls", "PostFAQExport", sheetHeader);
        else if (fileName.includes('Training_Update_Status_Results'))
          this.ExportFAQ(downloadData, fileName + ".xls", "TrainingUpdateStatus", sheetHeader);
        else
          this.ExportData(downloadData, fileName + ".xlsx", "Sheet 1");

      } catch (e: any) {
        this.loaderService.hideLoader();
        this.topNotificationService.showNotification("Failed to download reults", NotificationType.Error);
        console.log(e.message);
      }
      e.preventDefault();
    }
    else if (resultFileId != null && resultFileId != undefined) {
      this.loaderService.showLoader();
      this.storageService.getFileSaSUri(resultFileId).then((result) => {
        if (result.Success) {
          if (result.Data.FileSaSUri != null && result.Data.FileSaSUri != '' && result.Data.FileSaSUri != undefined)
            window.open(result.Data.FileSaSUri, '_blank', 'noreferrer');
        }
        else
          this.topNotificationService.showNotification("Failed to download file", NotificationType.Error);
      }).catch(() => {

      }).finally(() => {
        this.loaderService.hideLoader();

      });
      e.preventDefault();
    }
    
  }

  ExportFAQ(data: Array<any>, fileName: string, sheetName: string, sheetHeader: Array<any>) {
    let dataSource = [];
    if (data.length > 0) {
      let dataHeader: any = {};
      let headerkeys = _.keys(data[0]);
      headerkeys.forEach((item) => { dataHeader[item] = item; });
      sheetHeader.forEach((item, index) => { dataSource.push(item); });
      dataSource.push(dataHeader);
      data.forEach((item) => { dataSource.push(item); });
    }
    this.CreateTableFromJSONObj(dataSource);

    this.PostExport("tblPostFAQExport", fileName, sheetName);
    this.loaderService.hideLoader();
  }

  ExportData(data: Array<any>, fileName: any, sheetName: any) {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, fileName);
    this.loaderService.hideLoader();
  }

  CreateTableFromJSONObj(dataSource: any) {
    var col = [];
    for (let i = 0; i < dataSource.length; i++) {
      for (let key in dataSource[i]) {
        if (col.indexOf(key) === -1) {
          col.push(key);
        }
      }
    }

    // CREATE DYNAMIC TABLE.
    let table = document.createElement("table");
    table.setAttribute("id", "tblPostFAQExport");

    // ADD JSON DATA TO THE TABLE AS ROWS.   
    for (let i = 0; i < dataSource.length; i++) {

      let tr = table.insertRow(-1);

      for (let j = 0; j < col.length; j++) {
        let tabCell = tr.insertCell(-1);
        tabCell.innerHTML = dataSource[i][col[j]] != undefined ? dataSource[i][col[j]] : '';
      }
    }

    // FINALLY ADD THE NEWLY CREATED TABLE WITH JSON DATA TO A CONTAINER.
    let divContainer = document.getElementById("divhidden");
    if (!divContainer) {
      var elm = document.createElement("div");
      elm.setAttribute("id", "divhidden");
      elm.style.display = "none";
      document.body.appendChild(elm);
      divContainer = elm;
    }
    divContainer.innerHTML = "";
    divContainer.appendChild(table);
  }

  PostExport = (() => {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
      , base64 = (s: any) => { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = (s: any, c: any) => {
        return s.replace(/{(\w+)}/g, (m: any, p: any) => { return c[p]; }).replaceAll('<br>', '<br style="mso-data-placement:same-cell;" />').replaceAll('<br />', '<br style="mso-data-placement:same-cell;" />')
          .replace('<td>Process Action</td>', '<td style="font-weight:bold;">Process Action</td>')
          .replace('<td>Message Type</td>', '<td style="font-weight:bold;">Message Type</td>')
          .replace('<td>Message</td>', '<td style="font-weight:bold;">Message</td>')
          .replace('<td>Topic *</td>', '<td style="font-weight:bold;">Topic <span style="color:red;">*</span></td>')
          .replace('<td>Subtopic *</td>', '<td style="font-weight:bold;">Subtopic <span style="color:red;">*</span></td>')
          .replace('<td>Question *</td>', '<td style="font-weight:bold;">Question <span style="color:red;">*</span></td>')
          .replace('<td>Answer *</td>', '<td style="font-weight:bold;">Answer <span style="color:red;">*</span></td>')
      }
    return (table: any, filename: any, sheetname: any) => {
      if (!table.nodeType) table = document.getElementById(table);
      let ctx = { worksheet: sheetname || 'Worksheet', table: table.innerHTML }
      let link = document.createElement("a");
      link.download = filename;
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })();

  loadNotifications(userId: string) {
    this.storageService
      .getUserNotifications(userId)
      .then((data) => {
        if (data) {
          data.forEach((objItem) => {
            const MessageTypeString = this.getNotificationMessageTypeString(
              objItem.MessageType
            );
            const MessageTitleString = this.getNotificationMessageTitleString(
              objItem.MessageType
            );
            objItem.Date = moment(objItem.DateModified).format(
              Constants.MOMENT_DATE_TIME_FMT
            );
            objItem.StatusImg = ""
              .concat(environment.cdnEndPoint, environment.cdnSharedIconsFolder)
              .concat(MessageTypeString.toLowerCase(), ".svg");
            objItem.StatusCls = MessageTypeString.toLowerCase();
            objItem.Status = MessageTitleString;
          });
          this.signalList = data;
          this.setNotificationIcon();
        }
      })
      .catch((err) => {
        this.loggingService.Error(
          `<MedPoint.WebApp.TriPort.Shared.UserNotificationComponent.getUserNotifications> failed to retrieve UserNotifications with error=${err.error}`
        );
      })
      .finally(() => {

      });

    let sub = this.signalrService.signalUserNotificationReceived.subscribe((signal: UserNotification) => {

      const MessageTypeString = this.getNotificationMessageTypeString(signal.MessageType);
      const MessageTitleString = this.getNotificationMessageTitleString(signal.MessageType);
      if (signal.IsActive) {
        let config = { closeButton: signal.MessageType != MessageType.Inprogress, timeOut: 8000, newestOnTop: true, tapToDismiss: false, enableHtml: true, toastComponent: MedptToastComponent };
        this.medptToastr.show(signal.NotificationId, MessageTitleString, <string>this.sanitizer.bypassSecurityTrustHtml(signal.Message), signal.MessageType, config, signal);
      }

      const index = _.findIndex(this.signalList, (x) => x.NotificationId == signal.NotificationId);

      signal.IsActive = signal.IsActive;
      signal.DateModified = signal.DateModified;
      signal.Date = moment(signal.DateModified).format(Constants.MOMENT_DATE_TIME_FMT);
      signal.StatusImg = ""
        .concat(environment.cdnEndPoint, environment.cdnSharedIconsFolder)
        .concat(MessageTypeString.toLowerCase(), ".svg");
      signal.StatusCls = MessageTypeString.toLowerCase();
      signal.Status = MessageTitleString;

      if (signal.IsActive && index == -1) {
        this.signalList.push(signal);
      } else if (index !== -1) {
        this.signalList[index] = signal;
      }
      this.signalList = _.sortBy(this.signalList.filter(x => x.IsActive == true), (o) => { return moment(o.DateModified).format('YYYYMMDDHHMMSSSSSSSSS'); }).reverse();
      this.setNotificationIcon();
    });

    let sub1 = this.medptToastr.onRemoveToast.subscribe((data: any) => {
      this.closeNotification(null, data);
    });

    this.subscriptions.push(sub);
    this.subscriptions.push(sub1);
  }

  closeNotification($event: any, userNotification: UserNotification) {

    this.signalList = this.signalList.filter(
      (obj) => obj.NotificationId !== userNotification.NotificationId
    );
    this.setNotificationIcon();
    if ($event != null)
      $event.stopPropagation();

    userNotification.IsActive = false;
    userNotification.DateToExpire = moment.utc(new Date()).toDate();
    this.storageService
      .insertUserNotifications(userNotification)
      .then((data) => {
        if (data) {
          this.signalList = this.signalList.filter(
            (obj) => obj.NotificationId !== userNotification.NotificationId
          );
          this.setNotificationIcon();
        }
      });
  }

  getNotificationMessageTypeString(messageType: number) {
    return messageType == MessageType.Error
      ? "error"
      : messageType == MessageType.Info
        ? "info"
        : messageType == MessageType.Inprogress
          ? "inprogress"
          : messageType == MessageType.Success
            ? "success"
            : messageType == MessageType.Warning
              ? "warning"
              : "";
  }

  getNotificationMessageTitleString(messageType: number) {
    return messageType == MessageType.Error
      ? "Error"
      : messageType == MessageType.Info
        ? "Info"
        : messageType == MessageType.Inprogress
          ? "In Progress"
          : messageType == MessageType.Success
            ? "Success"
            : messageType == MessageType.Warning
              ? "Warning"
              : "";
  }

  setNotificationIcon() {
    const grouped = this.groupBy(this.signalList, (c: UserNotification) => c.MessageType);
    grouped.get(MessageType.Error)?.length;
    if (grouped.get(MessageType.Error)?.length > 0) {
      this.notificationIcon = "notif-bell-red.svg";
    } else if (grouped.get(MessageType.Warning)?.length > 0) {
      this.notificationIcon = "notif-bell-orange.svg";
    } else if (grouped.get(MessageType.Info)?.length > 0) {
      this.notificationIcon = "notif-bell-blue.svg";
    } else if (grouped.get(MessageType.Success)?.length > 0) {
      this.notificationIcon = "notif-bell-green.svg";
    } else {
      this.notificationIcon = "notif-bell.svg";
    }
  }

  groupBy(list: Array<UserNotification>, keyGetter: any) {
    const map = new Map();
    list.forEach((item: any) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  over(drop: NgbDropdown) {
    if (!drop.isOpen())
      drop.toggle();
  }

  notificationDropOut($event: any, drop: NgbDropdown) {
    let isInsideControl = $($event.toElement).parents('li').hasClass('topmenu-notification');
    if (!isInsideControl)
      drop.close();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((item, index) => {
      this.subscriptions[index].unsubscribe();
      delete this.subscriptions[index];
    });
    $(document).off('click touch', '.toast-container a');
  }
}
